module.exports = __webpack_public_path__ + "static/img/rotate07.f3c39ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/horse/rotate07.png
// module id = B1Ht
// module chunks = 1